var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	42180: () => (loadStrictVersionCheckFallback("default", "prop-types", [2,15,7,2], () => (__webpack_require__.e(5697).then(() => (() => (__webpack_require__(45697))))))),
	28394: () => (loadStrictVersionCheckFallback("default", "@fortawesome/fontawesome-svg-core", [2,1,3,0], () => (__webpack_require__.e(8947).then(() => (() => (__webpack_require__(78947))))))),
	31652: () => (loadStrictSingletonVersionCheckFallback("default", "react-dom", [4,17,0,2], () => (() => (__webpack_require__(73935))))),
	99640: () => (loadStrictVersionCheckFallback("default", "mobx", [2,3,6,2], () => (__webpack_require__.e(2188).then(() => (() => (__webpack_require__(22188))))))),
	90899: () => (loadStrictVersionCheckFallback("default", "moment", [2,2,29,4], () => (__webpack_require__.e(381).then(() => (() => (__webpack_require__(30381))))))),
	2670: () => (loadStrictVersionCheckFallback("default", "react-router", [2,5,3,4], () => (Promise.all([__webpack_require__.e(6550), __webpack_require__.e(5497)]).then(() => (() => (__webpack_require__(22111))))))),
	75497: () => (loadStrictVersionCheckFallback("default", "path-to-regexp", [2,3,1,0], () => (__webpack_require__.e(4779).then(() => (() => (__webpack_require__(14779))))))),
	13000: () => (loadStrictVersionCheckFallback("default", "classnames", [2,2,3,2], () => (__webpack_require__.e(4184).then(() => (() => (__webpack_require__(94184))))))),
	1534: () => (loadStrictVersionCheckFallback("default", "react-product-fruits", [2,2,2,5], () => (__webpack_require__.e(1731).then(() => (() => (__webpack_require__(61731))))))),
	9397: () => (loadStrictVersionCheckFallback("default", "react-virtuoso", [2,2,4,1], () => (__webpack_require__.e(348).then(() => (() => (__webpack_require__(20348))))))),
	11381: () => (loadStrictVersionCheckFallback("default", "react-collapsed", [2,3,3,1], () => (__webpack_require__.e(8475).then(() => (() => (__webpack_require__(58475))))))),
	13910: () => (loadStrictVersionCheckFallback("default", "react-grid-system", [1,8,1,9], () => (__webpack_require__.e(2553).then(() => (() => (__webpack_require__(32553))))))),
	17030: () => (loadStrictVersionCheckFallback("default", "@hotmart-org-ca/react-beautiful-dnd", [4,13,1,2], () => (__webpack_require__.e(9587).then(() => (() => (__webpack_require__(99587))))))),
	21457: () => (loadStrictVersionCheckFallback("default", "@fortawesome/pro-light-svg-icons", [2,6,0,0], () => (__webpack_require__.e(6203).then(() => (() => (__webpack_require__(26203))))))),
	22419: () => (loadStrictVersionCheckFallback("default", "ua-parser-js", [1,1,0,37], () => (__webpack_require__.e(2238).then(() => (() => (__webpack_require__(42238))))))),
	24394: () => (loadStrictVersionCheckFallback("default", "react-color", [2,2,18,1], () => (__webpack_require__.e(4198).then(() => (() => (__webpack_require__(24198))))))),
	25755: () => (loadStrictVersionCheckFallback("default", "react-input-range", [2,1,3,0], () => (__webpack_require__.e(9322).then(() => (() => (__webpack_require__(9322))))))),
	25845: () => (loadStrictVersionCheckFallback("default", "fabric", [2,4,3,1], () => (Promise.all([__webpack_require__.e(2777), __webpack_require__.e(9478)]).then(() => (() => (__webpack_require__(32777))))))),
	25901: () => (loadStrictVersionCheck("default", "util", [2,0,12,5])),
	28793: () => (loadStrictVersionCheckFallback("default", "react-dates", [2,21,8,0], () => (__webpack_require__.e(6141).then(() => (() => (__webpack_require__(76141))))))),
	31508: () => (loadStrictVersionCheckFallback("default", "util", [2,0,12,5], () => (__webpack_require__.e(9539).then(() => (() => (__webpack_require__(89539))))))),
	31956: () => (loadStrictVersionCheckFallback("default", "@fortawesome/react-fontawesome", [2,0,1,17], () => (__webpack_require__.e(7814).then(() => (() => (__webpack_require__(67814))))))),
	35003: () => (loadStrictVersionCheckFallback("default", "react-dropzone", [2,8,0,3], () => (__webpack_require__.e(4265).then(() => (() => (__webpack_require__(14265))))))),
	44013: () => (loadStrictVersionCheckFallback("default", "uuid", [1,9,0,1], () => (__webpack_require__.e(7017).then(() => (() => (__webpack_require__(77017))))))),
	45526: () => (loadStrictVersionCheckFallback("default", "js-cookie", [2,2,2,0], () => (__webpack_require__.e(6808).then(() => (() => (__webpack_require__(36808))))))),
	46756: () => (loadStrictVersionCheckFallback("default", "@hotmart/file-uploader", [2,1,4,12], () => (__webpack_require__.e(3125).then(() => (() => (__webpack_require__(13125))))))),
	48608: () => (loadStrictVersionCheckFallback("default", "@sentry/react", [2,7,66,0], () => (__webpack_require__.e(7160).then(() => (() => (__webpack_require__(57160))))))),
	52845: () => (loadStrictVersionCheckFallback("default", "mobx-react", [4,4,4,3], () => (__webpack_require__.e(7062).then(() => (() => (__webpack_require__(77062))))))),
	57814: () => (loadStrictVersionCheckFallback("default", "jquery", [2,3,5,0], () => (__webpack_require__.e(9755).then(() => (() => (__webpack_require__(19755))))))),
	61253: () => (loadStrictVersionCheckFallback("default", "moment-timezone", [2,0,5,38], () => (__webpack_require__.e(8).then(() => (() => (__webpack_require__(80008))))))),
	62003: () => (loadStrictVersionCheckFallback("default", "@hotmart/devsec-toolkit", [2,0,1,9], () => (__webpack_require__.e(3215).then(() => (() => (__webpack_require__(23215))))))),
	65068: () => (loadStrictVersionCheckFallback("default", "node-polyglot", [2,2,4,0], () => (__webpack_require__.e(2359).then(() => (() => (__webpack_require__(54078))))))),
	71375: () => (loadStrictVersionCheckFallback("default", "query-string", [2,6,12,1], () => (__webpack_require__.e(7563).then(() => (() => (__webpack_require__(17563))))))),
	75928: () => (loadStrictVersionCheckFallback("default", "fontfaceobserver", [2,2,1,0], () => (__webpack_require__.e(7347).then(() => (() => (__webpack_require__(37347))))))),
	76191: () => (loadStrictVersionCheckFallback("default", "react-avatar-editor", [4,11,0,7], () => (__webpack_require__.e(7011).then(() => (() => (__webpack_require__(27011))))))),
	76864: () => (loadStrictVersionCheckFallback("default", "react-select", [2,3,2,0], () => (__webpack_require__.e(7831).then(() => (() => (__webpack_require__(77831))))))),
	78242: () => (loadStrictVersionCheckFallback("default", "react-loading-skeleton", [2,3,0,2], () => (__webpack_require__.e(4849).then(() => (() => (__webpack_require__(84849))))))),
	79416: () => (loadStrictVersionCheckFallback("default", "@hotmart/request", [2,1,0,6], () => (__webpack_require__.e(5167).then(() => (() => (__webpack_require__(85167))))))),
	83286: () => (loadStrictVersionCheckFallback("default", "@hotmart/error-tracker-ui", [2,1,0,7], () => (__webpack_require__.e(7597).then(() => (() => (__webpack_require__(27597))))))),
	89765: () => (loadStrictVersionCheckFallback("default", "@fortawesome/pro-solid-svg-icons", [2,6,0,0], () => (__webpack_require__.e(2565).then(() => (() => (__webpack_require__(92565))))))),
	90073: () => (loadStrictVersionCheckFallback("default", "@fortawesome/pro-regular-svg-icons", [2,6,0,0], () => (__webpack_require__.e(2825).then(() => (() => (__webpack_require__(2825))))))),
	91377: () => (loadStrictVersionCheckFallback("default", "react-text-mask", [2,5,4,3], () => (__webpack_require__.e(1749).then(() => (() => (__webpack_require__(91749))))))),
	92522: () => (loadStrictVersionCheckFallback("default", "react-router-dom", [2,5,3,4], () => (__webpack_require__.e(3727).then(() => (() => (__webpack_require__(73727))))))),
	93593: () => (loadStrictVersionCheckFallback("default", "@hotmart/oauth-ui", [2,1,2,14], () => (__webpack_require__.e(7390).then(() => (() => (__webpack_require__(7390))))))),
	97793: () => (loadStrictVersionCheckFallback("default", "@hotmart/event-agent-js", [2,1,1,2], () => (__webpack_require__.e(3483).then(() => (() => (__webpack_require__(53483))))))),
	97912: () => (loadSingletonVersionCheckFallback("default", "@hotmart/club-files-ui", [1,2,0,8], () => (__webpack_require__.e(8315).then(() => (() => (__webpack_require__(48315))))))),
	98513: () => (loadStrictVersionCheckFallback("default", "react-quill", [2,1,3,3], () => (Promise.all([__webpack_require__.e(7762), __webpack_require__.e(1167)]).then(() => (() => (__webpack_require__(71167))))))),
	307: () => (loadStrictVersionCheckFallback("default", "countries-and-timezones", [2,3,3,0], () => (__webpack_require__.e(2091).then(() => (() => (__webpack_require__(22091))))))),
	66497: () => (loadStrictVersionCheckFallback("default", "date-fns", [2,1,30,1], () => (__webpack_require__.e(7292).then(() => (() => (__webpack_require__(47292))))))),
	89642: () => (loadStrictVersionCheckFallback("default", "lodash", [2,4,17,21], () => (__webpack_require__.e(6486).then(() => (() => (__webpack_require__(96486))))))),
	91043: () => (loadStrictVersionCheckFallback("default", "react-highcharts", [2,16,1,0], () => (__webpack_require__.e(920).then(() => (() => (__webpack_require__(10920))))))),
	49982: () => (loadStrictVersionCheckFallback("default", "recharts", [1,2,8,0], () => (__webpack_require__.e(3844).then(() => (() => (__webpack_require__(53844))))))),
	53426: () => (loadStrictSingletonVersionCheckFallback("default", "react", [4,17,0,2], () => (() => (__webpack_require__(67294))))),
	90487: () => (loadSingletonVersionCheckFallback("default", "scheduler", [2,0,20,2], () => (() => (__webpack_require__(63840)))))
};
var initialConsumes = [53426,90487];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"899": [
		90899
	],
	"1652": [
		31652
	],
	"2180": [
		42180
	],
	"2549": [
		91043
	],
	"2670": [
		2670
	],
	"3000": [
		13000
	],
	"5217": [
		49982
	],
	"5497": [
		75497
	],
	"8394": [
		28394
	],
	"8665": [
		1534,
		9397,
		11381,
		13910,
		17030,
		21457,
		22419,
		24394,
		25755,
		25845,
		25901,
		28793,
		31508,
		31956,
		35003,
		44013,
		45526,
		46756,
		48608,
		52845,
		57814,
		61253,
		62003,
		65068,
		71375,
		75928,
		76191,
		76864,
		78242,
		79416,
		83286,
		89765,
		90073,
		91377,
		92522,
		93593,
		97793,
		97912,
		98513
	],
	"9640": [
		99640
	],
	"9870": [
		307,
		66497,
		89642,
		90899
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}